import PageContentPreloader from './PageContentPreloader';

export default PageContentPreloader;
